<template>
  <d-form>
    <d-card class="card-small">
      <d-card-header class="border-bottom">
        <h6 class="m-0">Formas de pagamento</h6>
      </d-card-header>

      <d-card-body class="p-0 pb-1">
        <item-form-row
          ref="paymentInfoRows"
          :list="paymentInfo"
          :inline="true"
          :confirm-remove="true"
          type="paymentInfo"
          @saveItem="savePaymentInfo"
          @removeItem="openRemoveConfirm"
          placeholder="Adicione uma forma de pagamento"
        />
      </d-card-body>
    </d-card>
    <confirmation-modal
      :cancel="closeRemoveConfirm"
      :confirm="confirmRemovePaymentInfo"
      title="Confirme a exclusão"
      message="Tem certeza que deseja excluir essa forma de pagamento? Essa ação não pode ser desfeita."
    />
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SettingsService from '_services/rest/modules/settings';
import ContractualItems from '_common/mixins/ContractualItems';
import ItemFormRow from './ItemFormRow.vue';
import { OPTION } from './SettingsModel';

export default {
  name: 'payment-info-form',
  mixins: [ContractualItems],
  components: {
    ConfirmationModal,
    ItemFormRow,
  },
  data() {
    return {
      removeIndex: null,
    };
  },
  computed: {
    paymentInfo() {
      const { paymentInfo } = this.$store.state.settings;
      if (paymentInfo && paymentInfo.length > 0) {
        return paymentInfo;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions(['getPaymentInfo', 'activeAlert', 'setToggle']),
    openRemoveConfirm({ index }) {
      this.removeIndex = index;
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    closeRemoveConfirm() {
      this.removeIndex = null;
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    confirmRemovePaymentInfo() {
      const { paymentInfoRows } = this.$refs;
      if (this.removeIndex !== null && paymentInfoRows) {
        paymentInfoRows.removeRow(this.removeIndex);
      }
      this.closeRemoveConfirm();
    },
    savePaymentInfo({ index, type = 'paymentInfo' }) {
      const item = this[type][index];
      const name = item && item.name ? String(item.name).trim() : '';

      if (!name) {
        this.activeAlert({
          message: 'Informe o nome da forma de pagamento',
          theme: 'danger',
        });
        return;
      }

      item.name = name;
      this.formatSlug(item);
      SettingsService.saveQuotationContractualItems(item, 'payment_info')
        .then(response => {
          this.updateItem(index, type, response);
          this.activeAlert({
            message: 'Forma de pagamento salva com sucesso',
            theme: 'success',
          });
          if (this.paymentInfo.length === 1) this.getPaymentInfo();
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
  },
  mounted() {
    this.getPaymentInfo();
  },
};
</script>
